import Vue from "vue";
/*引入资源请求插件*/
import VueResource from "vue-resource";
/*使用VueResource插件*/
Vue.use(VueResource);
export const api = {
  async Login(data) {
    const res = await Vue.http.post("/api/login", data)
    return res
  },
  // 126、获取用户银行卡列表
  // 请求地址：/api/v1/settlement-card/list/{userId}
  // 请求方式:GET
  // 请求参数:
  // 字段	类型	是否必须	说明
  // userId	Long	是	用户

  // 请求样例
  // /api/v1/settlement-card/list/66
  async SettlementCardList(userId) {
    const res = await Vue.http.get("/api/v1/settlement-card/list/" + userId)
    this.removeItem(res)
    return res
  },
  //   127、用户银行卡-删除
  // 请求地址：/api/v1/settlement-card/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键

  // 请求样例
  // id=1908
  async SettlementCardDel(id) {
    const res = await Vue.http.post("/api/v1/settlement-card/del?id=" + id)
    this.removeItem(res)
    return res
  },
  async V1loVgout() {
    const res = await Vue.http.get("/api/v1/logout")
    this.removeItem(res)
    return res
  },
  async RoleList(data) {
    const res = await Vue.http.post("/api/v1/role/list", data)
    this.removeItem(res, "N")
    return res
  },
  async RoleEdit(data) {
    const res = await Vue.http.post("/api/v1/role/edit", data)
    this.removeItem(res)
    return res
  },
  async RoleEdit(data) {
    const res = await Vue.http.post("/api/v1/role/edit", data)
    this.removeItem(res)
    return res
  },
  async RoleDisable(id) {
    const res = await Vue.http.post("/api/v1/role/disable/" + id)
    this.removeItem(res)
    return res
  },
  async RoleEnable(id) {
    const res = await Vue.http.post("/api/v1/role/enable/" + id)
    this.removeItem(res)
    return res
  },
  async RoleDel(id) {
    const res = await Vue.http.post("/api/v1/role/del/" + id)
    this.removeItem(res)
    return res
  },
  async RoleAdd(data) {
    const res = await Vue.http.post("/api/v1/role/add", data)
    this.removeItem(res)
    return res
  },
  async PermissionListTree(id) {
    const res = await Vue.http.get("/api/v1/permission/listTree/" + id)
    this.removeItem(res)
    return res
  },
  async RoleAddPms(data) {
    const res = await Vue.http.post("/api/v1/role/addPms", data)
    this.removeItem(res)
    return res
  },
  async PermissionAdd(data) {
    const res = await Vue.http.post("/api/v1/permission/add", data)
    this.removeItem(res)
    return res
  },
  async PermissionEdit(data) {
    const res = await Vue.http.post("/api/v1/permission/edit", data)
    this.removeItem(res)
    return res
  },
  async PermissionDel(id) {
    const res = await Vue.http.post("/api/v1/permission/del/" + id)
    this.removeItem(res)
    return res
  },
  async NotifyList(data) {
    const res = await Vue.http.post("/api/v1/notify/list", data)
    this.removeItem(res)
    return res
  },
  async NotifyAdd(data) {
    const res = await Vue.http.post("/api/v1/notify/add", data)
    this.removeItem(res)
    return res
  },
  async UserList(data) {
    const res = await Vue.http.post("/api/v1/user/list", data)
    this.removeItem(res)
    return res
  },
  async UserAdd(data) {
    const res = await Vue.http.post("/api/v1/user/add", data)
    this.removeItem(res)
    return res
  },
  async UserFrozen(id) {
    const res = await Vue.http.post("/api/v1/user/frozen//" + id)
    this.removeItem(res)
    return res
  },
  async WithdrawList(data) {
    const res = await Vue.http.post("/api/v1/withdraw/list", data)
    this.removeItem(res)
    return res
  },
  async withdrawReject(data) {
    const res = await Vue.http.post("/api/v1/withdraw/reject", data)
    this.removeItem(res)
    return res
  },
  async AdminList(data) {
    const res = await Vue.http.post("/api/v1/admin/list", data)
    this.removeItem(res)
    return res
  },
  async AdminAddRoles(data) {
    const res = await Vue.http.post("/api/v1/admin/addRoles", data)
    this.removeItem(res)
    return res
  },
  async GetAllProduct(data) {
    const res = await Vue.http.post("/api/v1/product/getAllProduct", data)
    this.removeItem(res)
    return res
  },
  async GgetReward(data) {
    const res = await Vue.http.post("api/v1/reward/getReward", data)
    this.removeItem(res)
    return res
  },
  async GetAllUserProductInformation(data) {
    const res = await Vue.http.post("api/v1/information/getAllUserProductInformation", data)
    this.removeItem(res)
    return res
  },
  async DelRewardAmount(data) {
    const res = await Vue.http.post("api/v1/information/delRewardAmount", data)
    this.removeItem(res)
    return res
  },
  async PassedRewardAmount(data) {
    const res = await Vue.http.post("api/v1/information/passedRewardAmount", data)
    this.removeItem(res)
    return res
  },
  async CancelPassedRewardAmount(data) {
    const res = await Vue.http.post("api/v1/information/cancelPassedRewardAmount", data)
    this.removeItem(res)
    return res
  },
  async CancelDelRewardAmount(data) {
    const res = await Vue.http.post("api/v1/information/cancelDelRewardAmount", data)
    this.removeItem(res)
    return res
  },
  async SettlementRewardAmount(data) {
    const res = await Vue.http.post("api/v1/information/settlementRewardAmount", data)
    this.removeItem(res)
    return res
  },
  async SettlementDemotedAmount(data) {
    const res = await Vue.http.post("api/v1/information/settlementDemotedAmount", data)
    this.removeItem(res)
    return res
  },

  async CancelSettlementRewardAmount(data) {
    const res = await Vue.http.post("api/v1/information/cancelSettlementRewardAmount", data)
    this.removeItem(res)
    return res
  },
  async SettlementExtraAmount(data) {
    const res = await Vue.http.post("api/v1/information/settlementExtraAmount", data)
    this.removeItem(res)
    return res
  },
  async UsrTree() {
    const res = await Vue.http.get("api/v1/permission/usrTree")
    this.removeItem(res)
    return res
  },
  async GetAllProductUrl(data) {
    const res = await Vue.http.post("api/v1/replaceUrl/getAllProductUrl", data)
    this.removeItem(res, "i")
    return res
  },
  async UpdateProductUrl(data) {
    const res = await Vue.http.post("api/v1/replaceUrl/updateProductUrl", data)
    this.removeItem(res)
    return res
  },
  async CleanRealName(id) {
    const res = await Vue.http.post("api/v1/user/cleanRealName?id=" + id, {})
    this.removeItem(res)
    return res
  },
  async InformationGiftDel(id) {
    const res = await Vue.http.post("/api/v1/information-gift/del?id=" + id, {})
    this.removeItem(res)
    return res
  },
  async ProductGetGifts(id) {
    const res = await Vue.http.get("/api/v1/product/getGifts/" + id)
    this.removeItem(res)
    return res
  },
  async InformationGiftDelivery(id) {
    const res = await Vue.http.post("/api/v1/information-gift/delivery?id=" + id, {})
    this.removeItem(res)
    return res
  },
  async ProductDelGift(productId, giftId) {
    const res = await Vue.http.post("/api/v1/product/delGift?productId=" + productId + "&giftId=" + giftId, {})
    this.removeItem(res)
    return res
  },
  async ProductAddGifts(data) {
    const res = await Vue.http.post("/api/v1/product/addGifts", data)
    this.removeItem(res)
    return res
  },
  async InformationGiftQueryList(data) {
    const res = await Vue.http.post("/api/v1/information-gift/queryList", data)
    this.removeItem(res)
    return res
  },
  async InformationGiftQueryList(data) {
    const res = await Vue.http.post("/api/v1/information-gift/queryList", data)
    this.removeItem(res)
    return res
  },
  async ProductGiftDel(id) {
    const res = await Vue.http.post("/api/v1/product-gift/del?id=" + id, {})
    this.removeItem(res)
    return res
  },
  async ProductGiftQueryList(data) {
    const res = await Vue.http.post("/api/v1/product-gift/queryList", data)
    this.removeItem(res)
    return res
  },
  async ProductGiftEdit(data) {
    const res = await Vue.http.post("/api/v1/product-gift/edit", data)
    this.removeItem(res)
    return res
  },
  async ProductGiftAdd(data) {
    const res = await Vue.http.post("/api/v1/product-gift/add", data)
    this.removeItem(res)
    return res
  },
  async AddProductUrl(data) {
    const res = await Vue.http.post("api/v1/replaceUrl/addProductUrl", data)
    this.removeItem(res)
    return res
  },
  async DelProductUrl(data) {
    const res = await Vue.http.post("api/v1/replaceUrl/delProductUrl", data)
    this.removeItem(res)
    return res
  },
  async AddProduct(data) {
    const res = await Vue.http.post("api/v1/product/addProduct", data)
    this.removeItem(res)
    return res
  },
  async UpdateProduct(data) {
    const res = await Vue.http.post("api/v1/product/updateProduct", data)
    this.removeItem(res)
    return res
  },
  async ProductUploads(data) { //上传文件
    const res = await Vue.http.post("api/v1/product/uploads", data)
    this.removeItem(res)
    return res
  },
  async ProductDel(url) { //上传文件
    const res = await Vue.http.post("api/v1/product/del?name=" + url)
    this.removeItem(res)
    return res
  },
  async DelProduct(data) {
    const res = await Vue.http.post("api/v1/product/delProduct", data)
    this.removeItem(res)
    return res
  },
  async GetProvincesAll() {
    const res = await Vue.http.get("api/v1/provinces/getProvincesAll")
    this.removeItem(res)
    return res
  },
  async SelectAllScreening(data) {
    const res = await Vue.http.post("api/v1/screening/selectAllScreening", data)
    this.removeItem(res)
    return res
  },
  async AddScreening(data) {
    const res = await Vue.http.post("api/v1/screening/addScreening", data)
    this.removeItem(res)
    return res
  },
  async AddScreening(data) {
    const res = await Vue.http.post("api/v1/screening/addScreening", data)
    this.removeItem(res)
    return res
  },
  async AdminAdd(data) {
    const res = await Vue.http.post("/api/v1/admin/add", data)
    this.removeItem(res)
    return res
  },
  async WithdrawDraw(data) {
    const res = await Vue.http.post("/api/v1/withdraw/draw", data)
    this.removeItem(res)
    return res
  },
  async UserEdit(data) {
    const res = await Vue.http.post("/api/v1/user/edit", data)
    this.removeItem(res)
    return res
  },
  async GetAddHeiniuxian(data) {
    const res = await Vue.http.post("/api/v1/heiniuxian/getAddHeiniuxian", data)
    this.removeItem(res)
    return res
  },
  async Systempselect(pageNow) {
    const res = await Vue.http.post("/api/v1/parameter/getAllSystem", {
      pageNow,
    })
    this.removeItem(res);
    return res
  },
  async Systempadds(data) {
    const res = await Vue.http.post("/api/v1/parameter/addSystem", data)
    this.removeItem(res);
    return res
  },
  async AndroidUpload(data) {
    const res = await Vue.http.post("/api/version/android/upload", data)
    this.removeItem(res);
    return res
  },



  async Iosdeployupload(data) {
    const res = await Vue.http.post("/api/version/iosdeploy/upload", data)
    this.removeItem(res);
    return res
  },


  // 81、消息广播-查询列表
  // 请求地址：/api/v1/broadcast-msg/list
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  // state	Int	否	状态 0:禁用 1:正常
  async BroadcastMsgList(data) {
    const res = await Vue.http.post("/api/v1/broadcast-msg/list", data)
    this.removeItem(res);
    return res
  },
  // 82、消息广播-添加
  // 请求地址：/api/v1/broadcast-msg/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // msg	String	是	消息
  // state	Int	是	状态 0:禁用 1:正常
  // sort	Int	是	排序/降序
  async BroadcastMsgAdd(data) {
    const res = await Vue.http.post("/api/v1/broadcast-msg/add", data)
    this.removeItem(res);
    return res
  },
  //   83、消息广播-编辑
  // 请求地址：/api/v1/broadcast-msg/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  // msg	String	是	消息
  // state	Int	是	状态 0:禁用 1:正常
  // sort	Int	是	排序/降序
  async BroadcastMsgEdit(data) {
    const res = await Vue.http.post("/api/v1/broadcast-msg/edit", data)
    this.removeItem(res);
    return res
  },
  //   84、消息广播-删除
  // 请求地址：/api/v1/broadcast-msg/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键

  // 请求样例
  // /api/v1/broadcast-msg/del?id=6
  async BroadcastMsgDel(id) {
    const res = await Vue.http.post("/api/v1/broadcast-msg/del?id=" + id, {})
    this.removeItem(res);
    return res
  },
  async Systempdelete(id) {
    const res = await Vue.http.post("/api/v1/parameter/delSystem", {
      id
    })
    this.removeItem(res);
    return res
  },

  async Systempupdate(data) {
    const res = await Vue.http.post("/api/v1/parameter/updateSystem", data)
    this.removeItem(res);
    return res
  },


  async GetIdProduct(id) {
    const res = await Vue.http.post("/api/v1/product/getIdProduct", {
      id
    })
    this.removeItem(res);
    return res
  },
  async UserGet(id) {
    const res = await Vue.http.get("/api/v1/user/get/" + id)
    this.removeItem(res);
    return res
  },
  async GetProductUrlId(id) {
    const res = await Vue.http.post("/api/v1/replaceUrl/getProductUrlId", {
      id
    })
    this.removeItem(res);
    return res
  },
  async RoleGet(id) {
    const res = await Vue.http.get("/api/v1/role/get/" + id)
    this.removeItem(res);
    return res
  },

  // 获取进件申请统计
  // GET
  // /api/v1/information/queryStatistics
  // 修改时间: 1 分钟前
  // 责任人:Spring017
  // 请求参数
  // 参数名	位置	参数类型	必填	说明
  // startTimeMillis	query	number	是	
  // 示例值：
  // 1649916925816
  // 说明：
  // 开始时间
  // endTimeMillis	query	number	是	
  // 示例值：
  // 1650003325830
  // 说明：
  // 结束时间
  async QueryStatistics(data) {
    const res = await Vue.http.post("/api/v1/statistics/sys", data)
    this.removeItem(res);
    return res
  },
  async StatisticsAdminSys(data) {
    const res = await Vue.http.post("/api/v1/statistics/adminSys", data)
    this.removeItem(res);
    return res
  },





  async PermissionGet(id) {
    const res = await Vue.http.get("/api/v1/permission/get/" + id)
    this.removeItem(res);
    return res
  },
  async DelScreening(id) {
    const res = await Vue.http.post("/api/v1/screening/delScreening", id)
    this.removeItem(res);
    return res
  },
  async GetInformationToExcel(data) {
    const res = await Vue.http.post("/api/v1/information/getInformationToExcel", data)
    this.removeItem(res);
    return res
  },
  async WithdrawDrawAYG(data) {
    const res = await Vue.http.post("/api/v1/withdraw/agydraw", data)
    this.removeItem(res)
    return res
  },
  async WithdrawRefund(data) {
    const res = await Vue.http.post("/api/v1/withdraw/refund", data)
    this.removeItem(res)
    return res
  },
  async UserChain(id) {
    const res = await Vue.http.get("/api/v1/user/chain/" + id)
    this.removeItem(res);
    return res
  },
  async CebApiQuery(orderId) {
    const res = await Vue.http.post("/api/v1/ceb-api/query?orderId=" + orderId, {})
    this.removeItem(res)
    return res
  },
  //   36、获取产品已绑定的用户列表

  // 请求地址：/api/v1/product/queryBindUsers
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	是	条数
  // id	Long	是	产品id
  async QueryBindUsers(data) {
    const res = await Vue.http.post("/api/v1/product/queryBindUsers", data)
    this.removeItem(res)
    return res
  },

  // Spring:
  // /api/v1/information/isOld?id=16

  // Spring:
  // 二卡

  // Spring:
  // isNewUser == 0

  async InformationIsOld(id) {
    const res = await Vue.http.post("/api/v1/information/isOld?id=" + id, {})
    this.removeItem(res)
    return res
  },

  //   67、活动-查询列表

  // 请求地址：/api/v1/activity/list
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数

  // 请求样例：
  // {
  //     "pageNow":1,
  // "pageSize":10
  // }
  async ActivityList(data) {
    const res = await Vue.http.post("/api/v1/activity/list", data)
    this.removeItem(res)
    return res
  },
  //   69、活动-添加

  // 请求地址：/api/v1/activity/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // title	String	是	活动标题
  // brief	String	否	简要概述/暂定
  // tag	String	否	标签/暂定
  // startTime	String	是	活动开始时间
  // endTime	String	是	活动结束时间
  // commission	Long	是	达标佣金/分
  // state	Int	是	状态: 0:未启用 1:已启用
  // type	Int	是	类型 1:拉新
  async ActivityAdd(data) {
    const res = await Vue.http.post("/api/v1/activity/add", data)
    this.removeItem(res)
    return res
  },

  // 70、活动-编辑

  // 请求地址：/api/v1/activity/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  // title	String	是	活动标题
  // brief	String	否	简要概述/暂定
  // tag	String	否	标签/暂定
  // startTime	String	是	活动开始时间
  // endTime	String	是	活动结束时间
  // commission	Long	是	达标佣金/分
  // state	Int	是	状态: 0:未启用 1:已启用
  // type	Int	是	类型 1:拉新
  async ActivityEdit(data) {
    const res = await Vue.http.post("/api/v1/activity/edit", data)
    this.removeItem(res)
    return res
  },
  // 71、活动-删除
  // 请求地址：/api/v1/activity/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  async ActivityDel(id) {
    const res = await Vue.http.post("/api/v1/activity/del?id=" + id, {})
    this.removeItem(res)
    return res
  },

  //   37、产品绑定的用户

  // 请求地址：/api/v1/product/bindUser
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	产品id
  // phone	String	是	用户手机号
  async ProductBindUser(data) {
    const res = await Vue.http.post("/api/v1/product/bindUser", data)
    this.removeItem(res)
    return res
  },
  //   38、删除产品绑定的用户

  // 请求地址：/api/v1/product/delBindUser
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	产品id
  // userId	Long	是	用户id
  async ProductDelBindUser(data) {
    const res = await Vue.http.post("/api/v1/product/delBindUser", data)
    this.removeItem(res)
    return res
  },
  //   39、团队办卡数量统计

  // 请求地址：/api/v1/information/teamStatistics
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // startMillisecond	Long	是	开始时间毫秒数
  // endMillisecond	Long	是	结束时间毫秒数
  async TeamStatistics(data) {
    const res = await Vue.http.post("/api/v1/statistics/team", data)
    this.removeItem(res)
    return res
  }, async StatisticsAdminTeam(data) {
    const res = await Vue.http.post("/api/v1/statistics/adminTeam", data)
    this.removeItem(res)
    return res
  },
  //   44、线下外部群-获取列表

  // 请求地址：/api/v1/outside-group/queryList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	是	条数

  // 请求样例：
  // {
  //     "pageNow":1,
  //     "pageSize":1
  // }
  async OutsideGroupQueryList(data) {
    const res = await Vue.http.post("/api/v1/outside-group/queryList", data)
    this.removeItem(res)
    return res
  },
  //   66、Copy产品用户组
  // 请求地址：/api/v1/product/copyBind
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // copyProductId	Long	是	要copy的产品id
  // productId	Long	是	目标产品

  // 请求样例

  // copyProductId=1&productId=2

  // 返回结果:
  async ProductCopyBind(copyProductId, productId) {
    const res = await Vue.http.post("/api/v1/product/copyBind?copyProductId=" + copyProductId + "&productId=" + productId, {})
    this.removeItem(res)
    return res
  },
  // 41、线下外部群-添加群组

  // 请求地址：/api/v1/outside-group/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	String	是	名称
  async OutsideGroupAdd(data) {
    const res = await Vue.http.post("/api/v1/outside-group/add", data)
    this.removeItem(res)
    return res
  },
  // 42、线下外部群-编辑群组
  // 请求地址：/api/v1/outside-group/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键id
  // name	String	是	名称
  async OutsideGroupEdit(data) {
    const res = await Vue.http.post("/api/v1/outside-group/edit", data)
    this.removeItem(res)
    return res
  },
  // 43、线下外部群-删除
  // 请求地址：/api/v1/outside-group/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键id

  // 请求样例:
  //  id=1
  async OutsideGroupDel(id) {
    const res = await Vue.http.post("/api/v1/outside-group/del?id=" + id)
    this.removeItem(res)
    return res
  },
  // 45、线下外部产品-获取列表

  // 请求地址：/api/v1/outside-product/queryList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	是	条数
  // groupId	Long	否	群组id(不传全部)

  async OutsideProductQueryList(data) {
    const res = await Vue.http.post("/api/v1/outside-product/queryList", data)
    this.removeItem(res)
    return res
  },
  // 46、线下外部产品-添加

  // 请求地址：/api/v1/outside-product/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	Stirng	是	名称
  // groupId	Long	是	群组id
  // commission	Long	是	佣金
  async OutsideProductAdd(data) {
    const res = await Vue.http.post("/api/v1/outside-product/add", data)
    this.removeItem(res)
    return res
  },
  // 47、线下外部产品-编辑
  // 请求地址：/api/v1/outside-product/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  // name	Stirng	否	名称
  // groupId	Long	否	群组id
  // commission	Long	否	佣金
  async OutsideProductEdit(data) {
    const res = await Vue.http.post("/api/v1/outside-product/edit", data)
    this.removeItem(res)
    return res
  },
  //   48、线下外部产品-删除
  // 请求地址：/api/v1/outside-product/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键id

  // 请求样例:
  //  id=1
  // 返回结果:
  async OutsideProductDel(id) {
    const res = await Vue.http.post("/api/v1/outside-product/del?id=" + id)
    this.removeItem(res)
    return res
  },
  // 51、线下外部订单-获取列表
  // 请求地址：/api/v1/information/queryList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  // startMillisecond	Long	否	开始时间(毫秒)
  // endMillisecond	Long	否	结束时间(毫秒)
  // username	String	否	用户(代理)名称/手机号
  // name	String	否	办理人名称
  // phone	String	否	办理人手机号
  // pinCodes	String	否	办理人证件号码(这名称起的垃圾)
  // productName	String	否	产品名称
  // state	Integer	否	结算状态 1:待确认 2:已完成 3:结算额外佣金 4:已作废 5:待激活面签
  // applyStatus	Integer	否	信用卡进件状态: 0:订单初始化  1:初审失败 2:初审通过 ,3:激活成功 4:已首刷 5:终审失败 6:终审成功
  // groupName	String	否	团队名称
  // outsideGroupName	String	否	外部线下群名称
  // outsideProductName	String	否	外部线下产品名称

  async OutsideOrderQueryList(data) {
    const res = await Vue.http.post("/api/v1/outside-order/queryList", data)
    this.removeItem(res)
    return res
  },
  // 50、线下外部订单-删除
  // 请求地址：/api/v1/outside-order/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键id

  // 请求样例:
  //  id=1
  async OutsideOrderDel(id) {
    const res = await Vue.http.post("/api/v1/outside-order/del?id=" + id)
    this.removeItem(res)
    return res
  },
  // 49、线下外部订单-添加

  // 请求地址：/api/v1/information/addOutsideOrder
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // informationId	Long	是	订单id
  // groupId	Long	是	外部群组id
  // productId	Long	是	外部产品id
  async AddOutsideOrder(data) {
    const res = await Vue.http.post("/api/v1/information/addOutsideOrder", data)
    this.removeItem(res)
    return res
  },
  //   52、产品分组-获取列表

  // 请求地址：/api/v1/product-group/queryList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	是	条数

  // 请求样例：
  // {
  //     "pageNow":1,
  // "pageSize":1
  // }
  async ProductGroupQueryList(data) {
    const res = await Vue.http.post("/api/v1/product-group/queryList", data)
    this.removeItem(res)
    return res
  },
  // 53、产品分组-添加

  // 请求地址：/api/v1/product-group/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	Stirng	是	名称
  // state	Integer	是	状态 0:禁用 1:正常
  async ProductGroupAdd(data) {
    const res = await Vue.http.post("/api/v1/product-group/add", data)
    this.removeItem(res)
    return res
  },
  // 54、产品分组-编辑

  // 请求地址：/api/v1/product-group/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	Stirng	是	名称
  // state	Integer	是	状态 0:禁用 1:正常
  // id	Long	是	主键
  async ProductGroupEdit(data) {
    const res = await Vue.http.post("/api/v1/product-group/edit", data)
    this.removeItem(res)
    return res
  },
  // 55、产品分组-删除
  // 请求地址：/api/v1/product-group/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键id

  // 请求样例:
  //  id=1
  async ProductGroupDel(id) {
    const res = await Vue.http.post("/api/v1/product-group/del?id=" + id, {})
    this.removeItem(res)
    return res
  },

  // 56、产品产品列表(包含用户绑定关系)
  // 请求地址：/api/v1/product/queryBindProductList
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // productGroupId	Long	是	分组id

  // 请求样例:
  // /api/v1/product/queryBindProductList?productGroupId=1

  // 返回结果:
  async QueryBindProductList(productGroupId, userId) {
    const res = await Vue.http.post("/api/v1/product/queryBindProductList?productGroupId=" + productGroupId + "&userId=" + userId, {})
    this.removeItem(res)
    return res
  },

  //   57、产品用户批量绑定

  // 请求地址：/api/v1/produc/batchBind
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	字段1	类型	是否必须	说明
  // bindUserId		Long	是	要绑定的用户id
  // products		Long	是	产品集合
  // 	id	Long	是	产品id
  // 	isBind	Int	是	绑定状态 0:取消绑定 1:绑定

  // 请求样例:
  // {
  // 	"bindUserId": 1,
  // 	"products": [{

  // 			"id": 12,
  // 			"isBind": 1
  // 		},
  // 		{
  // 			"id": 13,
  // 			"isBind": 1
  // 		}
  // 	]
  // }
  async ProducBatchBind(data) {
    const res = await Vue.http.post("/api/v1/product/batchBind", data)
    this.removeItem(res)
    return res
  },
  // 58、修改订单状态
  // 请求地址：/api/v1/information/editApplyStatus
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  // applyStatus	Long	是	状态 


  // 请求样例：
  // /api/v1/information/editApplyStatus?id=239873&applyStatus=1

  async EditApplyStatus(id, applyStatus) {
    const res = await Vue.http.post("/api/v1/information/editApplyStatus?id=" + id + "&applyStatus=" + applyStatus, {})
    this.removeItem(res)
    return res
  },
  // 59、用户组-查询列表

  // 请求地址：/api/v1/user-group/queryList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  // state	int	否	状态 0:禁用 1:正常

  // 请求样例：
  // {
  //     "pageNow":1,
  // "pageSize":1
  // }

  // 返回结果:

  async UserGroupQueryList(data) {
    const res = await Vue.http.post("/api/v1/user-group/queryList", data)
    this.removeItem(res)
    return res
  },

  // 60、用户组-添加

  // 请求地址：/api/v1/user-group/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	Stirng	是	名称
  // state	Integer	是	状态 0:禁用 1:正常
  async UserGroupAdd(data) {
    const res = await Vue.http.post("/api/v1/user-group/add", data)
    this.removeItem(res)
    return res
  },

  // 61、用户组-编辑

  // 请求地址：/api/v1/user-group/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	Stirng	是	名称
  // state	Integer	是	状态 0:禁用 1:正常
  // id	Long	是	主键
  async UserGroupEdit(data) {
    const res = await Vue.http.post("/api/v1/user-group/edit", data)
    this.removeItem(res)
    return res
  },
  //   62、用户组-删除
  // 请求地址：/api/v1/user-group/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键id
  async UserGroupDel(id) {
    const res = await Vue.http.post("/api/v1/user-group/del?id=" + id, {})
    this.removeItem(res)
    return res
  },
  //   63、用户组-查询用户列表

  // 请求地址：/api/v1/user-group/userList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  // groupId	Bigint	是	分组id
  async UserGroupUserList(data) {
    const res = await Vue.http.post("/api/v1/user-group/userList", data)
    this.removeItem(res)
    return res
  },
  //   64、用户组-添加用户
  // 请求地址：/api/v1/user-group/useradd
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // groupId	Long	是	分组id
  // phone	String	是	手机号 
  async UserGroupUseradd(groupId, phone) {
    const res = await Vue.http.post("/api/v1/user-group/useradd?groupId=" + groupId + "&phone=" + phone, {})
    this.removeItem(res)
    return res
  },
  //   65、用户组-删除用户
  // 请求地址：/api/v1/user-group/userdel
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // groupId	Long	是	分组id
  // userId	Long	是	用户id

  // 请求样例
  // groupId=1&userId=1
  async UserGroupUserdel(groupId, userId) {
    const res = await Vue.http.post("/api/v1/user-group/userdel?groupId=" + groupId + "&userId=" + userId, {})
    this.removeItem(res)
    return res
  },

  //     68、	获取群发模板列表
  //  请求地址:/api/v1/wtemp/list
  //  请求方式:POST
  //  参数类型:application/json
  //  请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  async WtempList(data) {
    const res = await Vue.http.post("/api/v1/wechat-template/list", data)
    this.removeItem(res)
    return res
  },
  // 66、 修改群发模板
  // 请求地址： / api / v1 / wtemp / edit
  // 请求方式: POST,
  // 参数类型: application / json
  // 请求参数：
  // 字段 类型 是否必须 说明
  // id Long 是 主键
  // templateId String 是 模板id
  // title String 是 标题
  // first String 是 表示行
  // keywords String 是 内容
  // remark String 是 备注
  async WtempEdit(data) {
    const res = await Vue.http.post("/api/v1/wechat-template/edit", data)
    this.removeItem(res)
    return res
  },
  // 65、 新增群发模板
  // 请求地址： / api / v1 / wtemp / add
  // 请求方式: POST,
  // 参数类型: application / json
  // 请求参数：
  // 字段 类型 是否必须 说明
  // templateId String 是 模板id
  // title String 是 标题
  // first String 是 表示行
  // keywords String 是 内容
  // remark String 是 备注
  async WtempAdd(data) {
    const res = await Vue.http.post("/api/v1/wechat-template/add", data)
    this.removeItem(res)
    return res
  },


  // 69、 删除群发模板
  // 请求地址： / api / v1 / wtemp / del / {
  //     id
  // }
  // 请求方式: POST
  // 请求参数：
  // 字段 类型 是否必须 说明
  // id Long 是 主键
  async WtempDel(id) {
    const res = await Vue.http.post("/api/v1/wechat-template/del/" + id)
    this.removeItem(res)
    return res
  },

  //     67、	获取群发模板详情
  // 请求地址：/api/v1/wtemp/get/{id}
  // 请求方式:GET,
  // 请求参数：
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  async WtempGet(id) {
    const res = await Vue.http.get("/api/v1/wechat-template/get/" + id)
    this.removeItem(res)
    return res
  },
  // 70、 获取群发消息列表
  // 请求地址: /api/v1 / wechat / history
  // 请求方式: POST
  // 参数类型: application / json
  // 请求参数: 字段 类型 是否必须 说明
  // pageNow Integer 是 页码
  // pageSize Integer 否 条数
  // state Integer 否 状态 0: 执行中 1: 已完成 2: 已暂停
  async WechatHistory(data) {
    const res = await Vue.http.post("/api/v1/wechat-push-msg/history", data)
    this.removeItem(res)
    return res
  },
  //     72、	推送群发消息
  // 请求地址：/api/v1/wechat/pushMsg
  // 请求方式:POST,
  // 参数类型:application/json
  // 请求参数：
  // 字段	类型	是否必须	说明
  // templateId	Long	是	模板id[取模板主键]
  // title	String	是	标题[取模板标题]
  // first	String	是	标题行[对象字符串]
  // keywords	String	是	内容[数组字符串]
  // remark	String	是	备注[字符串]
  // threads	Integer	是	并发任务数量/n(数量加大，服务器资源消耗增加,处理时间减少效率增高)
  async WechatPushMsg(data) {
    const res = await Vue.http.post("/api/v1/wechat-push-msg/pushMsg", data)
    this.removeItem(res)
    return res
  },
  // 72、微信消息重发
  // 请求地址：/api/v1/wechat-push-msg/resendMsg
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 说明：只有状态已完成且失败数量大于0才可以此接口
  // 字段	类型	是否必须	说明
  // id	Long	是	主键

  // 请求样例
  // /api/v1/wechat-push-msg/resendMsg?id=41
  async ResendMsg(id) {
    const res = await Vue.http.post("/api/v1/wechat-push-msg/resendMsg?id=" + id, {})
    this.removeItem(res)
    return res
  },
  // 73、弹窗-查询列表

  // 请求地址：/api/v1/popups/list
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数

  // 请求样例：
  // {
  //     "pageNow":1,
  // "pageSize":10
  // }
  async PopupsList(data) {
    const res = await Vue.http.post("/api/v1/popups/list", data)
    this.removeItem(res)
    return res
  },

  //   75、弹窗-添加
  // 请求地址：/api/v1/popups/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // title	String	是	标题
  // pic	String	是	图片
  // url	String	是	跳转地址
  // type	Int	是	类型 0:弹窗 1:悬浮窗
  // visible	Int	是	可见范围 0:所有人 1:指定
  // state	Int	是	状态 0:禁用 1:正常
  // sort	Int	是	排序/降序
  async PopupsAdd(data) {
    const res = await Vue.http.post("/api/v1/popups/add", data)
    this.removeItem(res)
    return res
  },
  //   76、弹窗-编辑
  // 请求地址：/api/v1/popups/edit
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  // title	String	否	标题
  // pic	String	否	图片
  // url	String	否	跳转地址
  // type	Int	否	类型 0:弹窗 1:悬浮窗
  // visible	Int	否	可见范围 0:所有人 1:指定
  // state	Int	否	状态 0:禁用 1:正常
  // sort	Int	否	排序/降序
  async PopupsEdit(data) {
    const res = await Vue.http.post("/api/v1/popups/edit", data)
    this.removeItem(res)
    return res
  },
  //   77、弹窗-删除
  // 请求地址：/api/v1/popups/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  async PopupsDel(id) {
    const res = await Vue.http.post("/api/v1/popups/del?id=" + id)
    this.removeItem(res)
    return res
  },



  // 78、弹窗-查询用户列表
  // 说明:当数据 visible值为1时可调用此接口
  // 请求地址：/api/v1/popups/user/list
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  // popupsId	Long	是	弹窗id

  async PopupsUserList(data) {
    const res = await Vue.http.post("/api/v1/popups/user/list", data)
    this.removeItem(res)
    return res
  },
  // 80、弹窗-删除用户
  // 请求地址：/api/v1/popups/user/del
  // 请求方式:POST
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键

  // 请求样例
  // id=1
  async PopupsUserDel(id) {
    const res = await Vue.http.post("/api/v1/popups/user/del?id=" + id)
    this.removeItem(res)
    return res
  },
  //   79、弹窗-添加用户
  // 说明:当数据 visible值为1时可调用此接口
  // 请求地址：/api/v1/popups/user/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // popupsId	Long	是	弹窗id
  // userId	Long	是	用户id(拉取用户列表)
  async PopupsUserAdd(data) {
    const res = await Vue.http.post("/api/v1/popups/user/add", data)
    this.removeItem(res)
    return res
  },
  // 44、获取数据记录列表
  // 请求地址:/api/v1/data-record/list
  // 请求方式:GET,
  // 参数类型:x-www-form-urlencode
  // 请求参数:
  // 字段	类型	是否必须	说明
  // date	Long	是	主键

  // /api/v1/data-record/list?date=2022-11-15
  async DataRecordList(date) {
    const res = await Vue.http.get("/api/v1/data-record/list?date=" + date)
    this.removeItem(res)
    return res
  },
  // 45、添加数据记录
  // 请求地址:/api/v1/data-record/add
  // 请求方式:POST,
  // 参数类型:application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // name	String	是	产品名称
  // upUpdateQuantity	Int	是	上有更新数量
  // settlementQuantity	Int	是	结算数量
  // updateTime	String	是	更新时间
  async DataRecordAdd(data) {
    const res = await Vue.http.post("/api/v1/data-record/add", data)
    this.removeItem(res)
    return res
  },
  //   46、编辑数据记录
  // 请求地址:/api/v1/data-record/edit
  // 请求方式:POST,
  // 参数类型:application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  // name	String	是	产品名称
  // upUpdateQuantity	Int	是	上有更新数量
  // settlementQuantity	Int	是	结算数量
  // // updateTime	String	是	更新时间
  async DataRecordEdit(data) {
    const res = await Vue.http.post("/api/v1/data-record/edit", data)
    this.removeItem(res)
    return res
  },


  // 47、数据记录删除
  // 请求地址:/api/v1/information/invalid
  // 请求方式:POST
  // 参数类型:x-www-form-urlencode

  // 字段	类型	是否必须	说明
  // id	Long	是	主键id

  // 请求样例:
  // /api/v1/data-record/del?id=3
  // 返回结果:

  // {
  //     "status": 1,
  //     "message": "操作成功",
  //     "data": null
  // }
  //   110、产品管理-白名单列表
  // 请求地址：/api/v1/product/whitelistUsers
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Integer	是	页码
  // pageSize	Integer	否	条数
  // productId

  // 请求样例：
  // {
  //     "pageNow":1,
  //     "pageSize":1,
  //     "productId":1
  // }
  async WhitelistUsers(data) {
    const res = await Vue.http.post("/api/v1/product/whitelistUsers", data)
    this.removeItem(res)
    return res
  },
  //   111、产品管理-添加白名单
  // 请求地址：/api/v1/product/addWhitelist
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // productId	Long	是	产品ID
  // userId	Long	是	用户ID
  async AddWhitelist(data) {
    const res = await Vue.http.post("/api/v1/product/addWhitelist", data)
    this.removeItem(res)
    return res
  },
  //   112、产品管理-删除白名单
  // 请求地址：/api/v1/product/delWhitelist
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键

  // 请求样例
  // {
  //     "id":2
  // }
  async DelWhitelist(data) {
    const res = await Vue.http.post("/api/v1/product/delWhitelist", data)
    this.removeItem(res)
    return res
  },
  //   129、产品屏蔽列表
  // 请求地址：/api/v1/product-shield-user/queryList
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // pageNow	Int	是	页码
  // pageSize	Int	否	条数
  // userId	Long	否	用户id
  async ProductShieldUserQueryList(data) {
    const res = await Vue.http.post("/api/v1/product-shield-user/queryList", data)
    this.removeItem(res)
    return res
  },
  //   131、产品屏蔽-添加
  // 请求地址：/api/v1/product-shield-user/add
  // 请求方式:POST
  // 参数类型：application/json
  // 请求参数:
  // 字段	类型	是否必须	说明
  // userId	String	是	用户ID
  // keywords	String	是	关键词

  // 请求样例
  // {
  //     "userId": 66,
  //     "keywords": "广发"
  // }  
  async ProductShieldUserAdd(data) {
    const res = await Vue.http.post("/api/v1/product-shield-user/add", data)
    this.removeItem(res)
    return res
  },
  //   132、产品屏蔽-删除
  // 请求地址：/api/v1/product-shield-user/del
  // 请求方式:GET
  // 参数类型：application/x-www-form-urlencoded
  // 请求参数:
  // 字段	类型	是否必须	说明
  // id	Long	是	主键
  async ProductShieldUserDel(id) {
    const res = await Vue.http.post("/api/v1/product-shield-user/del?id=" + id, {})
    this.removeItem(res)
    return res
  },
  async DataRecordDel(id) {
    const res = await Vue.http.post("/api/v1/data-record/del?id=" + id)
    this.removeItem(res)
    return res
  },
  removeItem: (data, n) => {
    if (data.body.status == 10101) {
      localStorage.removeItem("token");
      window.location = '#/login';
    } else if (data.body.status != 1 && data.body.status != 310 && !n) {
      alert(data.body.message)
    }
  }
}